import { render, staticRenderFns } from "./movie-board.vue?vue&type=template&id=a7506002&"
import script from "./movie-board.vue?vue&type=script&lang=js&"
export * from "./movie-board.vue?vue&type=script&lang=js&"
import style0 from "./movie-board.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports